/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
  NotificationsDispatchPublicControllerResolveShortLinkPathParams,
  NotificationsDispatchPublicControllerResolveShortLink404,
} from '../../types/NotificationsDispatchPublicControllerResolveShortLink.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { notificationsDispatchPublicResolveShortLink } from '../../methods/notificationsDispatchPublicResolveShortLink.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const notificationsDispatchPublicResolveShortLinkQueryKey = (
  code: NotificationsDispatchPublicControllerResolveShortLinkPathParams['code'],
) => [{ url: '/api/telegram/notifications/short-links/:code', params: { code: code } }] as const;

export type NotificationsDispatchPublicResolveShortLinkQueryKey = ReturnType<
  typeof notificationsDispatchPublicResolveShortLinkQueryKey
>;

export function notificationsDispatchPublicResolveShortLinkQueryOptions(
  code: NotificationsDispatchPublicControllerResolveShortLinkPathParams['code'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = notificationsDispatchPublicResolveShortLinkQueryKey(code);
  return queryOptions<
    NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
    ResponseErrorConfig<NotificationsDispatchPublicControllerResolveShortLink404>,
    NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
    typeof queryKey
  >({
    enabled: !!code,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return notificationsDispatchPublicResolveShortLink(code, config);
    },
  });
}

/**
 * {@link /api/telegram/notifications/short-links/:code}
 */
export function useNotificationsDispatchPublicResolveShortLink<
  TData = NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
  TQueryData = NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
  TQueryKey extends QueryKey = NotificationsDispatchPublicResolveShortLinkQueryKey,
>(
  code: NotificationsDispatchPublicControllerResolveShortLinkPathParams['code'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        NotificationsDispatchPublicControllerResolveShortLinkQueryResponse,
        ResponseErrorConfig<NotificationsDispatchPublicControllerResolveShortLink404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationsDispatchPublicResolveShortLinkQueryKey(code);

  const query = useQuery(
    {
      ...notificationsDispatchPublicResolveShortLinkQueryOptions(code, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<NotificationsDispatchPublicControllerResolveShortLink404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
